import { combineReducers } from 'redux';
import appReducer from './appReducer';
import userReducer from './userReducer';
import userStatusReducer from './userStatusReducer';

const rootReducer = combineReducers({
  app: appReducer,
  users: userReducer,
  userStatus: userStatusReducer
});
export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js